export interface SellingCompany {
  id: string;
  key: string;
  name: string;
  tel: string;
  fax: string;
  email: string;
  web: string;
  vATRegNo: string;
  companyRegNo: string;
  eORINo: string;
  logoPath: string;
  addressId: string;
  addressMultiLine: string;
  country: string;
  accountsReferenceKey: string;
  smtpPort: number;
  smtpHost: string;
  smtpUsername: string;
  smtpPassword: string;
  smtpSenderName: string;
  smtpSenderAddress: string;
  websiteURL: string;
  websiteUsername: string;
  websitePassword: string;
  allowFocQuestion: boolean;
  customerPriceList: boolean;
  standardPriceList: boolean;
  customerProductPrices: boolean;
  productPrices: boolean;
  connectionId: string;
}
